import { config } from '../../Config';

const FetchFiles = async (chatId = "default", extensionId = "default") => {
    const url = config.fetchFilesForChat;
    // const dev_url = "https://dev-dbot-functions.azurewebsites.net/api/fetch-files-for-chat?code=NcSLa6Et2d9xplFFfJYYst33GEZJ_8zUprcSiwANZprMAzFu84ezDQ=="
    
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ chatId, extensionId })
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch files: ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching files:', error);
        return [];
    }
};

export default FetchFiles;
